import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const PaymentDonePage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Auto-close the window after a short delay
    const timer = setTimeout(() => {
      window.close();
    }, 2000); // Close after 2 seconds

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-[#111111] mb-4">
          {t('purchase.payment.verification_complete')}
        </h1>
        <p className="text-[#666666]">
          {t('purchase.payment.closing_window')}
        </p>
      </div>
    </div>
  );
};

export default PaymentDonePage;
